import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import { ReactComponent as Mail } from "../../../assets/letter-contact.svg";
import { ReactComponent as ContactIcon } from "../../../assets/Path103.svg";
import { ReactComponent as Phone } from "../../../assets/phone-contact.svg";
import user_placeholder from "../../../assets/user-profile.jpg";
import schoolServices from "../../../services/schoolServices";
import Button from "../../Button";
import Modal from "../../Modal";

const ContactAccountManager = forwardRef(({}, ref) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [accountManagerInfo, setAccountManagerInfo] = useState(null);

  useImperativeHandle(ref, () => ({
    openModal() {
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const getSchoolAccountManager = async () => {
    try {
      const response = await schoolServices.getSchoolAccountManager();
      setAccountManagerInfo(response);
    } catch (error) {
      console.error("Error fetching teachers data:", error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      getSchoolAccountManager();
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      header={
        <div className="flex items-center justify-between">
          <p className="flex items-center gap-2 text-blue-500">
            <ContactIcon className="h-5 w-5" />
            {t("contact_account_manager")}
          </p>
        </div>
      }
      footer={
        <div className="sm:space-x-2">
          <Button color="white" variant="outlined" onClick={() => setIsOpen(false)} label={t("close")} />
        </div>
      }
    >
      {/* Modal Body Content */}
      <div className="contact-container space-y-6 p-6">
        {/* Account Manager Details */}
        <div className="flex items-center gap-4">
          <img src={user_placeholder} alt="Account Manager" className="h-16 w-16 rounded-full" />
          <div className="flex flex-col">
            <p className="text-lg font-semibold text-gray-800 dark:text-gray-100">
              {accountManagerInfo?.name}
            </p>
          </div>
        </div>

        {/* Contact Information */}
        <div className="space-y-4">
          <div className="flex items-center gap-4">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-100 text-blue-500">
              <Mail className="h-5 w-5" />
            </div>
            <p className="text-sm text-gray-700 dark:text-gray-200">
              <span className="font-semibold">{t("email")}:</span>{" "}
              <a href={`mailto:${accountManagerInfo?.email}`} className="text-blue-500 hover:underline">
                {accountManagerInfo?.email}
              </a>
            </p>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-100 text-blue-500">
              <Phone className="h-5 w-5" />
            </div>
            <p className="text-sm text-gray-700 dark:text-gray-200">
              <span className="font-semibold">{t("phone")}:</span>{" "}
              <a href={`tel:${accountManagerInfo?.phone}`} className="text-blue-500 hover:underline">
                {accountManagerInfo?.phone}
              </a>
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
});

export default ContactAccountManager;
